import { render, staticRenderFns } from "./FrequencyData.vue?vue&type=template&id=7c4d879a&scoped=true&"
import script from "./FrequencyData.vue?vue&type=script&lang=js&"
export * from "./FrequencyData.vue?vue&type=script&lang=js&"
import style0 from "./FrequencyData.vue?vue&type=style&index=0&id=7c4d879a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4d879a",
  null
  
)

export default component.exports